import { render, staticRenderFns } from "./homepage.html?vue&type=template&id=2cf152b2&scoped=true&"
import script from "./homepage.js?vue&type=script&lang=js&"
export * from "./homepage.js?vue&type=script&lang=js&"
import style0 from "./homepage.scss?vue&type=style&index=0&id=2cf152b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf152b2",
  null
  
)

export default component.exports